import { Box, Grid, Skeleton, Typography } from '@mui/material';

const TemplateDocumentGeneratingScreen = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={2}
      bgcolor="#fff"
    >
      <Typography variant="h5" gutterBottom>
        Hold tight..
      </Typography>
      <Typography variant="h5" gutterBottom>
        Your document is being generated
      </Typography>
      <Box width="80%">
        <Skeleton variant="text" height={40} />
        <Skeleton variant="text" height={40} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={60} />
          </Grid>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={60} />
          </Grid>
        </Grid>
        <Skeleton variant="text" height={40} />
        <Skeleton variant="text" height={40} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={60} />
          </Grid>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={60} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default TemplateDocumentGeneratingScreen;
